module.exports = __webpack_public_path__ + "static/media/stage9.dd39e67e.svg";